import jwt from '@/http/requests/auth/jwt'

export default {

  fetchOrganisations ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/organisation/list')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAgencies ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/agency/list')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchProviderAdvertisers ({ commit }, idAgency) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/provideradvertiser/list', { idAgency })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCustomers ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/customer/list/small')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchJobFeedTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/jobs/jobfeedtype/list')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCountries ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/country/list')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
